(function(){
  var COLORES=[
    {n:'Claro',v:'50083895148786',s:'400',h:'#F6C793'},
    {n:'Medio',v:'50083895181554',s:'401',h:'#B5762F'},
    {n:'Oscuro',v:'50083895214322',s:'402',h:'#4A2314'}
  ];
  // Escalera de precios. Para cambiar la oferta se toca SOLO esto, y hay que
  // ajustar el descuento automatico de Shopify que le corresponde:
  //   2 frascos -> descuento $510   (DiscountAutomaticNode/1520042672370)
  //   3 frascos -> descuento $1.020 (DiscountAutomaticNode/1520042737906)
  // Escalera pareja: cada frasco extra suma $740 de ingreso.
  var UNIT=990;
  var PACKS=[
    {q:1,total:990,sub:'para un mueble puntual'},
    {q:2,total:1290,badge:'El más elegido'},
    {q:3,total:1590}
  ];
  var qty=2, elegidos=[0,0,0], potePos=0;
  function fmt(n){ return '$'+n.toLocaleString('es-UY'); }
  function pack(){ for(var i=0;i<PACKS.length;i++){ if(PACKS[i].q===qty) return PACKS[i]; } return PACKS[0]; }
  var mount=document.getElementById('msel-mount'); if(!mount) return;
  mount.innerHTML='<div class="msel" data-msel>'
    +'<div class="msel__head"><span class="msel__step">PASO 1</span><h3 class="msel__title">Elegí cuántos</h3></div>'
    +'<div class="msel__qty" data-qty></div>'
    +'<div class="msel__head msel__head--2"><span class="msel__step">PASO 2</span><h3 class="msel__title" data-t2>Elegí el tono</h3><span class="msel__pick" data-pick></span></div>'
    +'<div class="msel__potes" data-potes></div>'
    +'<div class="msel__grid msel__grid--3" data-grid></div>'
    +'<div class="msel__total" data-total></div>'
    +'</div>';
  var root=mount.querySelector('[data-msel]');
  function pintarPacks(){
    var h='';
    PACKS.forEach(function(p){
      var lleno=UNIT*p.q, cu=Math.round(p.total/p.q), save=lleno-p.total;
      h+='<button type="button" class="msel__pack'+(p.q===qty?' is-on':'')+'" data-q="'+p.q+'">';
      if(p.badge){ h+='<span class="msel__badge">'+p.badge+'</span>'; }
      h+='<span class="msel__radio"></span><span class="msel__packtxt"><b>'+p.q+(p.q===1?' frasco':' frascos')+'</b><small>'+(p.sub||fmt(cu)+' cada uno')+'</small>';
      if(save>0){ h+='<span class="msel__save">ahorrás '+fmt(save)+'</span>'; }
      h+='</span><span class="msel__packprice"><b>'+fmt(p.total)+'</b>'+(p.q>1?'<s>'+fmt(lleno)+'</s>':'')+'</span></button>';
    });
    root.querySelector('[data-qty]').innerHTML=h;
  }
  function pintarPotes(){
    var cont=root.querySelector('[data-potes]');
    if(qty===1){ cont.innerHTML=''; cont.style.display='none'; return; }
    cont.style.display='';
    var h='';
    for(var i=0;i<qty;i++){
      var c=COLORES[elegidos[i]];
      h+='<button type="button" class="msel__pote'+(i===potePos?' is-on':'')+'" data-pote="'+i+'">'
        +'<span class="msel__potedot" style="background:'+c.h+'"></span>'
        +'<span class="msel__potetxt"><b>Frasco '+(i+1)+'</b><small>'+c.n+'</small></span></button>';
    }
    cont.innerHTML=h;
  }
  function pintarGrid(){
    var h='';
    COLORES.forEach(function(c,i){
      h+='<button type="button" class="msel__opt'+(i===elegidos[potePos]?' is-on':'')+'" data-c="'+i+'" aria-label="'+c.n+'">'
        +'<span class="msel__chip" style="background:'+c.h+'"></span><span class="msel__label">'+c.n+'</span></button>';
    });
    root.querySelector('[data-grid]').innerHTML=h;
    root.querySelector('[data-t2]').textContent = qty===1 ? 'Elegí el tono' : 'Elegí el tono de cada frasco';
    root.querySelector('[data-pick]').textContent = qty===1 ? COLORES[elegidos[0]].n : 'Frasco '+(potePos+1);
  }
  function pintarTotal(){
    var p=pack(), lleno=UNIT*p.q;
    root.querySelector('[data-total]').innerHTML='<span class="msel__tlab">Total</span><span class="msel__tval">'+fmt(p.total)+'</span>'+(p.q>1?'<s>'+fmt(lleno)+'</s>':'');
  }
  function pintar(){ pintarPacks(); pintarPotes(); pintarGrid(); pintarTotal(); }
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-q]');
    if(b){ qty=parseInt(b.getAttribute('data-q'),10);
      if(potePos>=qty){ potePos=qty-1; }
      for(var i=1;i<qty;i++){ if(elegidos[i]===undefined){ elegidos[i]=elegidos[0]; } }
      pintar(); return; }
    var p=e.target.closest('[data-pote]');
    if(p){ potePos=parseInt(p.getAttribute('data-pote'),10); pintarPotes(); pintarGrid(); return; }
    var c=e.target.closest('[data-c]');
    if(c){ elegidos[potePos]=parseInt(c.getAttribute('data-c'),10);
      if(qty>1 && potePos<qty-1){ potePos++; }
      pintarPotes(); pintarGrid(); return; }
  });
  function items(){
    var map={};
    for(var i=0;i<qty;i++){ var v=COLORES[elegidos[i]].v; map[v]=(map[v]||0)+1; }
    return Object.keys(map).map(function(v){ return {id:parseInt(v,10), quantity:map[v]}; });
  }
  function abrirCarrito(){
    var d=document.querySelector('cart-drawer');
    if(d && typeof d.open==='function'){ try{ d.open(); return; }catch(e){} }
    window.location.href='/cart';
  }
  [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'))
   .filter(function(f){ return !f.closest('#shopify-section-cart-drawer'); })
   .forEach(function(f){
      f.addEventListener('submit',function(ev){
        ev.preventDefault(); ev.stopImmediatePropagation();
        var btn=f.querySelector('[name="add"], .product-form__submit');
        if(btn){ btn.disabled=true; }
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:items()})})
          .then(function(r){ return r.json(); })
          .then(function(){ if(btn){ btn.disabled=false; } abrirCarrito(); })
          .catch(function(){ if(btn){ btn.disabled=false; } window.location.href='/cart'; });
      }, true);
   });
  pintar();
})();